// tslint:disable: cyclomatic-complexity
import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../../Utils';
import { IFocusControl, IInputError } from '../../common';
import { sharedLabelStyles, sharedRadioInputStyles } from '../common';

export const RadioLabelSpan = Styled.span`
  vertical-align: text-top;
`;

export const RadioBadgeLabel = Styled.label`
  ${sharedLabelStyles}
  text-align: center;

  ${({ theme }) => {
    const themeTwo = theme.themeTwo;
    const { form: { radio: { badge }}} = themeTwo;

    return css`
      font-weight: ${badge.font.weight && badge.font.weight};
      line-height: ${badge.font.lineHeight && badge.font.lineHeight};

      /* background-color */ ${badge.backgroundColor && cssDeclaration(themeTwo, 'background-color', badge.backgroundColor)};
      /* color */ ${badge.font && badge.font.color && cssDeclaration(themeTwo, 'color', badge.font.color)};
      /* font-size */ ${badge.font.size && cssDeclaration(themeTwo, 'font-size', badge.font.size)};
      /* border */ ${cssDeclaration(themeTwo, 'border', badge.border)};
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', badge.round)};
      /* width */ ${cssDeclaration(themeTwo, 'width', badge.width)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', badge.padding)};
    `;
  }}
`;

export const RadioBadgeInput = Styled.input<IInputError & IFocusControl>`
  ${sharedRadioInputStyles};

  ${({ theme, error, clickFocus }) => {
    const themeTwo = theme.themeTwo;
    const { form: { radio: { badge }}} = themeTwo;
    const {
      state: {
        checked,
        checkedHover,
        disabled,
        disabledChecked,
        error: errorState,
        focus,
        hover,
      },
    } = badge;

    return css`
      &:checked + ${RadioBadgeLabel} {
        /* background-color */ ${checked.backgroundColor && cssDeclaration(themeTwo, 'background-color', checked.backgroundColor)};
        /* color */ ${checked.font && checked.font.color && cssDeclaration(themeTwo, 'color', checked.font.color)};
        /* border */ ${checked.border && cssDeclaration(themeTwo, 'border', checked.border)};
        /* box-shadow */ ${checked.shadow && cssDeclaration(themeTwo, 'box-shadow', checked.shadow)};
      }

      &:checked:hover + ${RadioBadgeLabel} {
        /* color */ ${checkedHover.font && checkedHover.font.color && cssDeclaration(themeTwo, 'color', checkedHover.font.color)};
        /* border */ ${checkedHover.border && cssDeclaration(themeTwo, 'border', checkedHover.border)};
        /* box-shadow */ ${checkedHover.shadow && cssDeclaration(themeTwo, 'box-shadow', checkedHover.shadow)};
        /* background-color */
        ${checkedHover.backgroundColor &&
          cssDeclaration(themeTwo, 'background-color', checkedHover.backgroundColor)
        };
      }

      &:disabled + ${RadioBadgeLabel} {
        cursor: not-allowed;
        /* background-color */ ${disabled.backgroundColor && cssDeclaration(themeTwo, 'background-color', disabled.backgroundColor)};
        /* color */ ${disabled.font && disabled.font.color && cssDeclaration(themeTwo, 'color', disabled.font.color)};
        /* border */ ${disabled.border && cssDeclaration(themeTwo, 'border', disabled.border)};
        /* box-shadow */ ${disabled.shadow && cssDeclaration(themeTwo, 'box-shadow', disabled.shadow)};

        &:hover {
          /* color */ ${disabled.font && disabled.font.color && cssDeclaration(themeTwo, 'color', disabled.font.color)};
          /* border */ ${disabled.border && cssDeclaration(themeTwo, 'border', disabled.border)};
          /* box-shadow */ ${disabled.shadow && cssDeclaration(themeTwo, 'box-shadow', disabled.shadow)};
        }
      }

      &:disabled:checked + ${RadioBadgeLabel} {
        cursor: not-allowed;
        /* color */ ${disabledChecked.font && disabledChecked.font.color && cssDeclaration(themeTwo, 'color', disabledChecked.font.color)};
        /* border */ ${disabledChecked.border && cssDeclaration(themeTwo, 'border', disabledChecked.border)};
        /* box-shadow */ ${disabledChecked.shadow && cssDeclaration(themeTwo, 'box-shadow', disabledChecked.shadow)};
        /* background-color */
        ${disabledChecked.backgroundColor &&
          cssDeclaration(themeTwo, 'background-color', disabledChecked.backgroundColor)
        };
      }

      &:hover + ${RadioBadgeLabel} {
        /* background-color */ ${hover.backgroundColor && cssDeclaration(themeTwo, 'background-color', hover.backgroundColor)};
        /* color */ ${hover.font && hover.font.color && cssDeclaration(themeTwo, 'color', hover.font.color)};
        /* border */ ${hover.border && cssDeclaration(themeTwo, 'border', hover.border)};
        /* box-shadow */ ${hover.shadow && cssDeclaration(themeTwo, 'box-shadow', hover.shadow)};
      }

      ${!clickFocus && css`
        &:focus + ${RadioBadgeLabel} {
          /* background-color */ ${focus.backgroundColor && cssDeclaration(themeTwo, 'background-color', focus.backgroundColor)};
          /* color */ ${focus.font && focus.font.color && cssDeclaration(themeTwo, 'color', focus.font.color)};
          /* border */ ${focus.border && cssDeclaration(themeTwo, 'border', focus.border)};
          /* box-shadow */ ${focus.shadow && cssDeclaration(themeTwo, 'box-shadow', focus.shadow)};

          ${focus.outline && css`
            /* outline */ ${cssDeclaration(themeTwo, 'outline', focus.outline)};
          `}
        }
      `}

      // error state
      ${error && css`
        & + ${RadioBadgeLabel} {
        /* background-color */ ${errorState.backgroundColor && cssDeclaration(themeTwo, 'background-color', errorState.backgroundColor)};
        /* color */ ${errorState.font && errorState.font.color && cssDeclaration(themeTwo, 'color', errorState.font.color)};
        /* border */ ${errorState.border && cssDeclaration(themeTwo, 'border', errorState.border)};
        /* box-shadow */ ${errorState.shadow && cssDeclaration(themeTwo, 'box-shadow', errorState.shadow)};
      `};
    `;
  }}
`;
